import { initPanel } from './panel.js';
import { initUpload } from './upload.js';
// document.getElementById('message').innerText = "The Square of 2 is " + viggo2(2);
// debugger;

import $ from "jquery";
import 'ol/ol.css';
import '../css/main.css';

import {
  Map,
  View
} from 'ol';
import {
  Draw,
  Modify,
  Snap
} from 'ol/interaction.js';
import TileLayer from 'ol/layer/Tile';
import {
  Image as ImageLayer,
  Vector as VectorLayer
} from 'ol/layer.js';
import {
  Zoom,
  ZoomSlider,
  ZoomToExtent
} from 'ol/control.js';
import {
  defaults as defaultInteractions,
  DragRotateAndZoom
} from 'ol/interaction.js';
import {
  getWidth,
  getTopLeft
} from 'ol/extent.js';
import {
  get as getProjection
} from 'ol/proj.js';
import {
  register
} from 'ol/proj/proj4.js';

import {
  Vector as VectorSource
} from 'ol/source.js';
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style
} from 'ol/style.js';
import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import proj4 from 'proj4';
import GeoJSON from 'ol/format/GeoJSON';

const websiteVisitCountRequest = new Request('/kostra_ws/upload', {
  method: 'OPTIONS'
});
fetch(websiteVisitCountRequest);

proj4.defs(
  "EPSG:25833",
  "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
);
register(proj4);
//var projection = ol.proj.get('EPSG:32633');
var projection = getProjection('EPSG:25833');
var drawNr = 0;
var maxArea = 20000; // dekar

var mapExtent = [-2500000.0, 3500000.0, 3045984.0, 9045984.0];
var resolutions = [21664,
  10832,
  5416,
  2708,
  1354,
  677,
  338.5,
  169.25,
  84.625,
  42.3125,
  21.15625,
  10.578125,
  5.2890625,
  2.64453125,
  1.322265625,
  0.6611328125,
  0.33056640625,
  0.165283203125
];
var matrixIds = new Array(resolutions.length);
for (var z = 0; z < resolutions.length; ++z) {
  // matrixIds[z] = 'EPSG:25833:' + z;
  matrixIds[z] = z;
}

// Background raster
var graatone = new TileLayer({
  title: 'Gråtone',
  id: 'GRAATONE',
  type: 'base',
  source: new WMTS({
     url: "https://cache.kartverket.no/v1/service?",
    //url: backgroundUrl,
    layer: 'topograatone',
    matrixSet: 'utm33n',
    format: 'image/png',
    projection: projection,
    tileGrid: new WMTSTileGrid({
      origin: getTopLeft(mapExtent),
      resolutions: resolutions,
      matrixIds: matrixIds
    }),
    style: 'default',
    extent: mapExtent,
  })
});

var dyrka = new ImageLayer({
  extent: [-1280314, 6154666, 2080314, 8513334],
  opacity: 0.7,
  maxResolution: 10,
  source: new ImageWMS({
    projection: projection,
    url: 'https://wms.nibio.no/cgi-bin/ar5',
    params: {
      'LAYERS': 'Jordbruksareal'
    }
  })
});

var dyrkbar = new ImageLayer({
  extent: [-1280314, 6154666, 2080314, 8513334],
  maxResolution: 10,
  source: new ImageWMS({
    projection: projection,
    url: 'https://wms.nibio.no/cgi-bin/dyrkbarjord_2',
    params: {
      'LAYERS': 'dyrkbar_jord',
    }
  })
});

var zoomOptions = {
  className: 'kostra-zoom',
  zoomInLabel: '',
  zoomOutLabel: '',
  zoomInTipLabel: 'Zoom inn',
  zoomOutTipLabel: 'Zoom ut',
};

var zoomSliderOptions = {
  className: 'ol-zoomslider'
};
var extentOptions = {
  extent: [-1280314, 6154666, 2080314, 8513334],
  tipLabel: 'Zoom til hele Norge',
  label: '',
  className: 'kostraExtent'
};

// DRAW / MODIFY //

var source = new VectorSource();
var vector = new VectorLayer({
  source: source,
  style: new Style({
    fill: new Fill({
      color: 'rgba(255, 0, 0, 0.2)'
    }),
    stroke: new Stroke({
      color: '#ff0000',
      width: 2
    }),
    image: new CircleStyle({
      radius: 7,
      fill: new Fill({
        color: '#ff0000'
      })
    })
  })
});

var draw, snap; // global so we can remove them later

var uniqId = function() {
  var uniq = Math.floor(Math.random() * 89999 + 10000);
  return uniq;
};

// End DRAW / MODIFY //

const map = new Map({
  target: 'map',
  layers: [graatone, dyrka, dyrkbar, vector],
  controls: [
    new Zoom(zoomOptions),
    new ZoomSlider(zoomSliderOptions),
    new ZoomToExtent(extentOptions)
  ],
  /*interactions:
  ]),*/
  view: new View({
    projection: projection,
    center: [378604, 7226208],
    zoom: 6,
    maxZoom: 20,
    minZoom: 6
    //center: [1006500, 8573000],
    //zoom: 10
  })
});

setMapSize();

function setMapSize() {

  //var infoWidth = Math.round((window.innerWidth / 3) - 10);
  //var mapWidth = Math.round((window.innerWidth / 3) * 2);
  var mapWidth = window.innerWidth;
  var mapHeight = window.innerHeight;


  $('#map').css({
    width: mapWidth + 'px',
    height: mapHeight + 'px'
  }); // change OpenLayers map *container* size
  map.setSize([mapWidth, mapHeight]); // adjust the map's size
  map.updateSize();

}

window.onresize = function(event) {
  setMapSize()
}

var modify = new Modify({
  source: source
});


export function addInteractions() {
  draw = new Draw({
    source: source,
    type: 'Polygon'
  });
  draw.on('drawend', function(e) {
    $('#list').show();
    drawNr++;
    var uniqID = uniqId();

    var area = e.feature.getGeometry().getArea();
    var dekar = Math.round(area/1000);

    if (dekar > maxArea ) {
       alert('Flaten er '+ dekar+ ' dekar. Maks størrelse for å kunne arealberegne er '+ maxArea +' dekar.' +
       ' Endre flaten eller slett og tegn en mindre flate.')
    }

      e.feature.setProperties({
        'id': uniqID,
        'text': 'Tegnet flate '+drawNr
      });

    $("#list ul").append('<li id=' + uniqID + '><div class="list_drawn">' +
      '<input type="text"  id="input_' + uniqID + '" class="inputText" value="Tegnet flate ' + drawNr + '"></input>' +
      '<button id=' + uniqID + ' class="btn-close" title="Slett"><i class="fas fa-trash-alt"></i></button>' +
      '</div> </li>');

    updateHoverList();
  });
  map.addInteraction(draw);
  snap = new Snap({
    source: source
  });
  map.addInteraction(modify);
  map.addInteraction(snap);

}

export function removeInteractions() {
  map.removeInteraction(draw);
  map.removeInteraction(modify);
  map.removeInteraction(snap);
};


export function beregnAreal() {

  var sendToServer = true;
  var toBigName = '';
  var toBigArea = 0;
  var drawnFeatures = vector.getSource().getFeatures();

  drawnFeatures.forEach(function(f) {
    var area = f.getGeometry().getArea();
    toBigArea = Math.round(area/1000);

    if (toBigArea > maxArea) {
      sendToServer = false;
      toBigName = f.getProperties().text;
    }
  });

  if (!sendToServer) {
    alert('Flaten ' +toBigName+' er '+ toBigArea+ ' dekar. Maks størrelse for å kunne arealberegne er '+ maxArea+' dekar.' +
    ' Endre flaten eller slett og tegn en mindre flate.')
  } else {

    var format = new GeoJSON();
    // write features to GeoJSON format using projection EPSG:4326
    var drawnJson = format.writeFeatures(drawnFeatures);
    //alert(drawn);
    $.ajax({
      url: '/kostra_ws/upload',
      type: 'POST',
      data: drawnJson,
      cache: false,
      contentType: false,
      //contentType: "charset=utf-8",
      processData: false,
      dataType: 'html',

      xhrFields: {
        withCredentials: true
      },
      beforeSend: function(xhr) {
        if ($('#uploadPanel').length === 0) {
          initUpload('draw');
        }
        $('.upload').hide();
        $('#resultDiv').show();
        $('#result').text('Beregner resultat...');
      },
      success: function(result, textStatus, status) {

        $('.upload').hide();
        $('#resultDiv').show();
        $('#result').html(result);
      },
      error: function(error) {
        $('#result').html('Noe feilet: ' + error.statusText + ' : ' + error.status);
      },
      /*  complete: function(complete) {

        }*/
    });
  }
}


function updateHoverList() {
  $('#list li').hover(function() {
    // debugger;
    var overid = this.id;
    setStyle(overid);
    jQuery(this).addClass('list-hover');
  }, function() {
    var overid = this.id;
    removeStyle(overid)
    jQuery(this).removeClass('list-hover');
  });
  $('.btn-close').click(function() {
    removeDraw(this);
  });

  $(".inputText").on('change keyup paste', function() {
    var element = $(this);
    var inId = element.attr("id");
    setNewText(inId);
  });
}


function removeDraw(button_in) {

  var poly_id = button_in.id;
  /// alert('Flate: ' + poly_id)
  removeFeature(poly_id);
  $("*[id=" + poly_id + "]").remove();
  if ($('#list li').length === 0) {
    $('#list').hide();
  }
}


function removeFeature(fid) {
  var removeFeature = getFeature(fid);
  vector.getSource().removeFeature(removeFeature);
}

function getFeature(sid) {
  var allFeatures = vector.getSource().getFeatures();
  for (var x = allFeatures.length; x-- > 0;) {
    if ((allFeatures[x].getProperties().id).toString() === sid) {
      return allFeatures[x];
    }
  }
}

function removeStyle(sid) {
  getFeature(sid).setStyle(new Style({
    stroke: new Stroke({
      color: 'rgba(255,0,0,1)',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(255,0,0,0.2)'
    })
  }));
}

function setStyle(sid) {
  getFeature(sid).setStyle(new Style({
    stroke: new Stroke({
      color: 'rgba(255,0,0,1)',
      width: 5
    }),
    fill: new Fill({
      color: 'rgba(255,0,0,0.7)'
    })
  }));
}

function setNewText(fid) {
  var split = fid.split('_');
  var text = $('#' + fid).val();
  getFeature(split[1]).setProperties({
    'text': text
  });
}

export function initUploadFunc() {
  initUpload('upload');
}

$(document).ready(function() {
  $('#open_info_button').click(function() {
    initPanel();
  });
  initPanel();
});
